import { CourseUserViewModel } from "../coursesApiSlice";
import CourseUsersTable from "./CourseUsersTable";

interface CourseTeachersProps {
	teachers: CourseUserViewModel[];
	courseId: number;
	schoolId: number;
	districtId: number;
}

export default function CourseTeachersSection(props: CourseTeachersProps) {
	return (
		<section>
			<hr className="my-6" />
			<h2>Teachers</h2>
			<CourseUsersTable
				users={props.teachers}
				courseId={props.courseId}
				schoolId={props.schoolId}
				districtId={props.districtId}
				displayLength={3}
				isTeacherTable={true}
			/>
		</section>
	);
}
